export const TICKET_STATUS_ID = {
	EXPIRED: 'TKE',
	ONSALE: 'TKO',
	PENDING: 'TKP',
	SOLD_OUT: 'TKS',
	TRASHED: 'TKA',
};

export const TICKET_STATUS_IDS = Object.values(TICKET_STATUS_ID);
